import { api } from '../../api/client';
import { processImage } from '../../utils/imageProcessing';

// Upload a user-chosen cover image for a personal Story: resize to a landscape
// cover, get a presigned S3 URL, PUT directly, and return the CDN url + a local
// preview. Mirrors uploadPlanImage in courses/growthApi.js.
export async function uploadStoryImage(file) {
  const { blob, type } = await processImage(file, { preset: 'cover' });
  const { uploadUrl, fileUrl } = await api.post('/api/upload/presign', {
    fileType: type,
    fileName: (file.name || 'story-cover').replace(/\.\w+$/, type === 'image/webp' ? '.webp' : '.jpg'),
    fileSize: blob.size,
  });
  await fetch(uploadUrl, { method: 'PUT', body: blob, headers: { 'Content-Type': type } });
  const previewUrl = URL.createObjectURL(blob);
  return { fileUrl, previewUrl };
}
